import { createSelector } from 'reselect'

export const get404 = createSelector(
  state => Boolean(state && state.common && state.common.is404),
  title => title
)
